import './locales/register'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { lazy, Suspense } from 'react'
import { Loading } from '@vnetwork/datacentral-ui/feedback'

const ThresholdList = lazy(() => import('./components/List'))
const ThresholdDetail = lazy(() => import('./components/Detail'))
const ThresholdCreate = lazy(() => import('./components/Create'))
const ThresholdEdit = lazy(() => import('./components/Edit'))

const LoadingFallback = () => <Loading />

const withSuspense = (Component: React.LazyExoticComponent<React.FC>) => (
    <Suspense fallback={<LoadingFallback />}>
        <Component />
    </Suspense>
)

const ThresholdModule: RouteObject = {
    path: 'technical/threshold',
    children: [
        { path: '', element: withSuspense(ThresholdList) },
        { path: 'new', element: withSuspense(ThresholdCreate) },
        { path: ':id', element: withSuspense(ThresholdDetail) },
        { path: ':id/edit', element: withSuspense(ThresholdEdit) },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ThresholdModule
